// src/utils/analytics.js
// Unified, safe analytics emitter (no-op if no provider is available).

const safeEmit = (fn) => {
  try {
    fn();
  } catch {
    // Analytics nunca deve quebrar o fluxo da UI.
  }
};

export function trackAnalyticsEvent(name, payload = {}) {
  const eventName = typeof name === 'string' ? name.trim() : '';
  if (!eventName) return;

  const data = payload && typeof payload === 'object' ? payload : { value: payload };

  if (typeof window === 'undefined') return;

  safeEmit(() => {
    window.dispatchEvent(
      new CustomEvent('bluezap:analytics', {
        detail: { name: eventName, payload: data },
      })
    );
  });

  safeEmit(() => window.analytics?.track?.(eventName, data));
  safeEmit(() => window.gtag?.('event', eventName, data));
  safeEmit(() => window.plausible?.(eventName, { props: data }));
  safeEmit(() => window.dataLayer?.push?.({ event: eventName, ...data }));
}
